import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const purchaseOrderIdInputSchema = z.object({
    purchaseOrderId: requiredUuidString('Purchase order id is required.', 'Invalid purchase order id.'),
});
//# sourceMappingURL=id-input.js.map